const _ = require("lodash");
const moment = require("moment");
const channelFields = require("../data/app__channelFields");

function enrichSnapshotWithId(querySnapshot) {
  const data = [];
  querySnapshot.forEach((doc) => {
    const elem = doc.data();
    elem.id = doc.id;
    data.push(elem);
  });
  return data;
}

function enrichRawData(rawData) {
  return rawData.data();
}

module.exports = function (firebase, logger) {
  return {
    copyCampaignATSSettings(campaignId, newCampaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("ats")
          .doc(campaignId)
          .get()
          .then((campaign) => {
            const newData = _.extend({}, campaign.data());

            if (!newData) {
              logger.log("error:copyCampaignATSSettings", "No ATS found (1)");
              return reject("No ATS found");
            }

            if (!newCampaignId) {
              logger.log("error:copyCampaignATSSettings", "No new campaign id passed in (3)");
              return reject("No ATS found");
            }

            if (newData.campaignData && newData.campaignData.lastIncomingMessageDate) {
              delete newData.campaignData.lastIncomingMessageDate;
            }

            if (newData.campaignData && newData.campaignData.unseenApplicantsCount) {
              delete newData.campaignData.unseenApplicantsCount;
            }

            this.collection("ats")
              .doc(newCampaignId)
              .set(newData, { merge: true })
              .then(fullfil)
              .catch(reject);
          })
          .catch((err) => {
            logger.log("error:copyCampaignATSSettings", "No ATS found (2)", err);
            return reject("No ATS found");
          });
      });
    },

    copyCampaign(campaignId, newUserId, newUserName) {
      const that = this;
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .get()
          .then((campaign) => {
            // Init new campaign object with old data
            const newData = _.extend({}, campaign.data());

            logger.log("FirebaseController:copyCampaign", "Start copying campaign data", {
              newData,
              campaignId,
              newUserId,
              newUserName
            });
            // Status
            delete newData.lastStatus;
            newData.isBookedViaSelfservice = "true";
            newData.status = "DRAFT";

            // User field
            newData.userId = newUserId;
            newData.userName = newUserName;

            newData.copyOfCampaignId = campaignId;

            // Job title and campaign name
            newData.campaignName = "Vorlage: " + newData.jobTitle;

            // Saves ad preview step
            newData.lastEditStage = "STEP_PREVIEWS_NEW";

            delete newData.facebookCampaigns;
            delete newData.googleAdsAccountId;

            // Delete all the fields from the social media channels
            channelFields.forEach((field) => {
              delete newData[field.name];
            });

            // Reset other invocies
            delete newData.invoiceId;
            delete newData.rechnungsNummer;
            delete newData.bookedInvoiceId;
            delete newData.poNumber;

            // reset connected campaign ids
            delete newData.idMapping;

            delete newData.requiresAttention;

            // Dates
            newData.createdDate = new Date().toISOString();
            delete newData.campaignLiveDate;
            delete newData.campaignFinishedDate;
            // Reset planned dates
            delete newData.startDate;
            //TODO:Do we have to deal with this differently?
            // because this field is now required
            delete newData.endDate;

            // Metrics
            delete newData.metrics;
            delete newData.metricsDaily;
            // Reset metrics
            delete newData.totalBudgetDailyHistory;
            delete newData.totalClicksDailyHistory;
            delete newData.totalBudgetHistory;
            delete newData.totalClicksHistory;
            delete newData.totalViewsApplicationForm;
            delete newData.dailyChannelPerformanceHistory;
            delete newData.applicantsCountHistory;

            delete newData.has404Error;

            delete newData.applicantsCount;
            delete newData.has404Error;
            delete newData.facebookCampaignPaused;

            // Its important to remove the old Front conversation URL
            // othwise its wronly associcated.
            delete newData.csmConversationUrl;

            // Page postIds
            delete newData.pagePostIds;
            delete newData.budgetMonitorDate;

            // Reset targeting
            delete newData.targetingFacebook;
            delete newData.targetingGoogleDisplay;
            delete newData.targetingYouTube;
            delete newData.targetingTwitter;

            return that
              .createCampaign(newData)
              .then((result) => {
                const newCampaignId = result && result.id;

                const responseData = _.extend({}, newData, {
                  campaignId: newCampaignId,
                  id: newCampaignId,
                  sourceCampaignData: campaign.data()
                });
                // We also need to copy the ad creatives entry for this campaign
                return fullfil(responseData);
              })
              .catch(reject);
          });
      });
    },

    duplicateCampaign(campaignId, newUserId, newUserName) {
      const that = this;
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .get()
          .then((campaign) => {
            // Init new campaign object with old data
            const newData = _.extend({}, campaign.data());

            logger.log("FirebaseController:duplicateCampaign", "Start copying campaign data", {
              newData,
              campaignId,
              newUserId,
              newUserName
            });
            // Status
            delete newData.lastStatus;
            newData.isBookedViaSelfservice = "true";
            newData.status = "WAITING_FOR_APPROVAL";

            // User field
            newData.userId = newUserId;
            newData.userName = newUserName;
            newData.copyOfCampaignId = campaignId;

            // Job title and campaign name
            newData.campaignName = "Verlängert: " + newData.jobTitle;
            // Reset all ad copies
            //delete newData.adwordsCampaignId; // Google Display
            delete newData.facebookCampaigns;
            delete newData.googleAdsAccountId;

            // Delete all the fields from the social media channels
            channelFields.forEach((field) => {
              delete newData[field.name];
            });

            // Reset other invocies
            delete newData.invoiceId;
            delete newData.rechnungsNummer;
            delete newData.bookedInvoiceId;
            delete newData.poNumber;

            // reset connected campaign ids
            delete newData.idMapping;

            delete newData.requiresAttention;

            // Dates
            newData.createdDate = new Date().toISOString();
            delete newData.campaignLiveDate;
            delete newData.campaignFinishedDate;
            // Reset planned dates
            delete newData.startDate;
            //TODO:Do we have to deal with this differently?
            // because this field is now required
            delete newData.endDate;

            // Metrics
            delete newData.metrics;
            delete newData.metricsDaily;
            // Reset metrics
            delete newData.totalBudgetDailyHistory;
            delete newData.totalClicksDailyHistory;
            delete newData.totalBudgetHistory;
            delete newData.totalClicksHistory;
            delete newData.totalViewsApplicationForm;
            delete newData.dailyChannelPerformanceHistory;
            delete newData.applicantsCountHistory;

            delete newData.has404Error;

            delete newData.applicantsCount;
            delete newData.has404Error;
            delete newData.facebookCampaignPaused;

            // Its important to remove the old Front conversation URL
            // othwise its wronly associcated.
            delete newData.csmConversationUrl;

            // Page postIds
            delete newData.pagePostIds;
            delete newData.budgetMonitorDate;

            // Reset targeting
            delete newData.targetingFacebook;
            delete newData.targetingGoogleDisplay;
            delete newData.targetingYouTube;
            delete newData.targetingTwitter;

            return that
              .createCampaign(newData)
              .then((result) => {
                const newCampaignId = result && result.id;

                const responseData = _.extend({}, newData, {
                  campaignId: newCampaignId,
                  id: newCampaignId,
                  sourceCampaignData: campaign.data()
                });
                // We also need to copy the ad creatives entry for this campaign
                return fullfil(responseData);
              })
              .catch(reject);
          });
      });
    },

    //==============================================================================
    // Campaigns Collection
    //==============================================================================
    createCampaignWithId(campaignId, newData) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns").doc(campaignId).set(newData).then(fullfil).catch(reject);
      });
    },
    createCampaignDraft(campaignDraft) {
      return new Promise((fullfil, reject) => {
        const ref = this.collection("campaigns").doc();
        ref
          .set(campaignDraft)
          .then(() => fullfil(ref))
          .catch(reject);
      });
    },
    updateCampaignDraft(campaignId, campaignDraft) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .set(campaignDraft, { merge: true })
          .then(fullfil)
          .catch(reject);
      });
    },
    deleteCampaignDraft(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns").doc(campaignId).delete().then(fullfil).catch(reject);
      });
    },
    createCampaign(newData, idForCampaign) {
      return new Promise((fullfil, reject) => {
        let campaignRef;
        if (idForCampaign) {
          campaignRef = this.collection("campaigns").doc(idForCampaign);
          logger.log(
            "AbstractFirebaseController:createCampaign",
            "case: an existing campaignId was pased in",
            {
              campaignId: idForCampaign
            }
          );
        } else {
          campaignRef = this.collection("campaigns").doc();
        }

        logger.log("AbstractFirebaseController:createCampaign", "Create campaign with reference", {
          campaignId: campaignRef.id,
          idForCampaign
        });
        // Increment the nr of campaigns for the organization after each booking
        campaignRef
          .set(newData)
          .then(async () => {
            logger.log("AbstractFirebaseController:createCampaign", "Saved new data", {
              campaignId: campaignRef.id,
              idForCampaign,
              newData
            });

            const campaign = await this.getCampaignWithId(campaignRef.id);
            const increment = firebase.firestore.FieldValue.increment(1);
            // Orga lookup in order to check if the firstBookingDate is set
            const orga = await this.collection("organizations").doc(newData.organizationId).get();
            const orgaData = orga.data();

            if (newData.status !== "DRAFT") {
              const dataToStore = {
                nrOfCampaigns: increment,
                lastBookingDate: new Date().toISOString()
              };

              if (
                !orgaData.firstBookingDate &&
                (!orgaData.nrOfCampaigns || orgaData.nrOfCampaigns == 0)
              ) {
                dataToStore.firstBookingDate = new Date().toISOString();
                campaign.isFirstCampaign = true;
              } else {
                campaign.isFirstCampaign = false;
              }

              this.collection("organizations")
                .doc(newData.organizationId)
                .update(dataToStore)
                .catch((err) => {
                  logger.log("error:createCampaign", "error creating nrOfCampaigns orgas", {
                    err,
                    newData,
                    campaignId: campaignRef.id
                  });
                });

              const incrementUser = firebase.firestore.FieldValue.increment(1);
              // Orga lookup in order to check if the firstBookingDate is set

              const dataToStoreUser = {
                nrOfCampaigns: incrementUser,
                lastBookingDate: new Date().toISOString()
              };

              this.collection("users")
                .doc(newData.userId)
                .update(dataToStoreUser)
                .catch((err) => {
                  logger.log("error:createCampaign", "error incrementing nrOfCampaigns users", {
                    err,
                    newData,
                    campaignId: campaignRef.id
                  });
                });
            }

            fullfil(campaign);
          })
          .catch((err) => {
            logger.log("error:AbstractFirebaseController:createCampaign", "error saving document", {
              err,
              campaignId: campaignRef.id,
              idForCampaign
            });
            reject(err);
          });
      });
    },
    createAdset(newData) {
      return new Promise((fullfil, reject) => {
        this.collection("adsets").add(newData).then(fullfil).catch(reject);
      });
    },
    getAdsetsWithCondition(field, operator, value) {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where(field, operator, value)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    updateAdset(adsetId, data) {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .doc(adsetId)
          .set(data, {
            merge: true
          })
          .then(fullfil)
          .catch(reject);
      });
    },
    loadAdset(adsetId) {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .doc(adsetId)
          .get()
          .then((querySnapshot) => fullfil(querySnapshot.data()))
          .catch(reject);
      });
    },
    loadAdsets(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where("campaignId", "==", campaignId)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    updateAdsetWithId(adsetId, data) {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .doc(adsetId)
          .set(data, { merge: true })
          .then(fullfil)
          .catch(reject);
      });
    },

    updateCampaignWithId(campaignId, data) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .set(data, { merge: true })
          .then(fullfil)
          .catch(reject);
      });
    },

    deleteCampaignField(campaignId, field) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .update({
            [field]: firebase.firestore.FieldValue.delete()
          })
          .then(fullfil)
          .catch(reject);
      });
    },
    addLocations(data) {
      return new Promise((fullfil, reject) => {
        this.collection("locations").doc().set(data).then(fullfil).catch(reject);
      });
    },
    getLocationByParams(location, country) {
      return new Promise((fullfil, reject) => {
        this.collection("locations")
          .where("location", "==", location)
          .where("country", "==", country)
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getLocationByParamsAndState(location, state, country) {
      return new Promise((fullfil, reject) => {
        this.collection("locations")
          .where("location", "==", location)
          .where("stateOfLoc", "==", state)
          .where("country", "==", country)
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    addChannelDataToCampaign(campaignId, newArrayItem) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .update({
            idMapping: firebase.firestore.FieldValue.arrayUnion(newArrayItem)
          })
          .then(fullfil)
          .catch(reject);
      });
    },

    getCampaignWithId(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .get()
          .then((snapshot) => fullfil({ id: snapshot.id, ...snapshot.data() }))
          .catch(reject);
      });
    },

    getCampaignWithExternalId(externalId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("externalId", "==", externalId)
          .limit(1)
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getCampaignsFromOrganizationId(organizationId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("organizationId", "==", organizationId)
          .get()
          .then(enrichSnapshotWithId)
          .then(fullfil)
          .catch(reject);
      });
    },
    getTikTokCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "tiktok")
          .get()
          .then(enrichSnapshotWithId)
          .then(fullfil)
          .catch(reject);
      });
    },
    getPinterestCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "pinterest")
          .get()
          .then(enrichSnapshotWithId)
          .then(fullfil)
          .catch(reject);
      });
    },
    getSpotifyCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "spotify")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getSnapchatCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "snapchat")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getTwitterCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "twitter")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getRedditCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "reddit")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getGoogleSearchAdsets() {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "google-search")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getEbayKleinanzeigenAdsets() {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "ebay-kleinanzeigen")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getYouTubeAdsets() {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "youtube")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getGoogleDisplayAdsets() {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "google-display")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getFacebookAdsets() {
      return new Promise((fullfil, reject) => {
        this.collection("adsets")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "facebook")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getFacebookCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "facebook")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getInstagramCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "instagram")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getInstagramAndFacebookCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains-any", ["instagram", "facebook"])
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getIndeedCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "indeed")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },

    getCampaignToBeEnded() {
      const now = moment().subtract(1, "day").hour(23).format();
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("endDate", "<", now)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    /**
     * Get all campaigns that are active with at least x days remaining
     */
    async getCampaignsWithRemaining({ days = 14 }) {
      const endDateLimit = moment().add(days, "days").hour(23).format();

      const querySnapshot = await this.collection("campaigns")
        .where("status", "==", "ACTIVE")
        .where("endDate", "<=", endDateLimit)
        .get();

      return enrichSnapshotWithId(querySnapshot);
    },
    getCampaignsWithRemainingDays(days = 5) {
      const endDate__start = moment()
        .add(days - 1, "days")
        .hour(0)
        .format();
      const endDate__stop = moment().add(days, "days").hour(23).format();
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("endDate", "<=", endDate__stop)
          .where("endDate", ">", endDate__start)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getFilteredCampaignsOfOrganization(orgaId, queries = []) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");

        let query = campaigns.where("organizationId", "==", orgaId);
        for (let singleQuery of queries) {
          const { field, operator, value } = singleQuery;
          query = query.where(field, operator, value);
        }

        query
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getCampaignsOfOrga(value, field, filter) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");

        var query = campaigns.where(field, "==", value);

        logger.debug("FirebaseController:getCampaignsOfOrga", "called", {
          value,
          field,
          filter
        });

        if (filter !== "ALL" && filter !== "ACTIVE_AND_IN_PROGRESS") {
          query = query.where("status", "==", filter);
        }

        if (filter === "ACTIVE_AND_IN_PROGRESS") {
          logger.debug("FirebaseController:getCampaignsOfOrga", "Special case", {
            value,
            filter
          });

          // NOTE: this method is a work arround until firestore allows OR conditions in queries!
          return this.getAllActiveOrPreperationCampaigns(value, field, fullfil, reject);
        }

        if (filter === "ACTIVE_AND_IN_PROGRESS_AND_DRAFTS") {
          logger.debug("FirebaseController:getCampaignsOfOrga", "Special case", {
            value,
            filter
          });

          // NOTE: this method is a work arround until firestore allows OR conditions in queries!
          return this.getAllActiveOrPreperationCampaigns(value, field, fullfil, reject, true);
        }

        logger.debug("FirebaseController:getCampaignsOfOrga", "Load all by filter....", {
          value,
          field,
          filter
        });

        // This is status ALL
        query
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },

    getAllActiveOrPreperationCampaignsByUserId(value, orderBy, fullfil, reject, data, userId) {
      return this.collection("campaigns")
        .where(orderBy, "==", value)
        .where("userId", "==", userId)
        .where("status", "in", [
          "ACTIVE",
          "IN_PROGRESS",
          "SCHEDULED",
          "WAITING_FOR_APPROVAL",
          "ACTION_REQUIRED",
          "COMMENT_ANSWER_NEEDED"
        ])
        .get()
        .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
        .catch(reject);
    },

    getAllActiveOrPreperationCampaigns(orgaId, orderBy, fullfil, reject, includeDrafts = false) {
      //
      // NOTE: this method is a work arround until firestore allows OR conditions in database queries!
      //
      const statuses = [
        "ACTIVE",
        "IN_PROGRESS",
        "SCHEDULED",
        "WAITING_FOR_APPROVAL",
        "ACTION_REQUIRED",
        "COMMENT_ANSWER_NEEDED"
      ];
      if (includeDrafts) {
        statuses.push("DRAFT");
      }
      return this.collection("campaigns")
        .where(orderBy, "==", orgaId)
        .where("status", "in", statuses)
        .get()
        .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
        .catch(reject);
    },

    getAllUserCampaignsByIdDb(userId) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");

        campaigns
          .where("userId", "==", userId)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },

    getCampaignsOfUserWithId(orgaId, orderBy, filter, userId) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");
        const data = [];
        let query = campaigns.where(orderBy, "==", orgaId).where("userId", "==", userId);

        if (filter !== "ALL" && filter !== "ACTIVE_AND_IN_PROGRESS") {
          return query
            .where("status", "==", filter)
            .get()
            .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
            .catch(reject);
        }

        if (filter === "ACTIVE_AND_IN_PROGRESS") {
          return this.getAllActiveOrPreperationCampaignsByUserId(
            orgaId,
            orderBy,
            fullfil,
            reject,
            data,
            userId
          );
        }
        // NOTE: this method is a work arround until firestore allows OR conditions in queries!

        query
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getAllBookedCampaignsWithCouponByOrga(orgaId, couponId) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");

        campaigns
          .where("organizationId", "==", orgaId)
          .where("couponId", "==", couponId)
          // statuses of a booked campaign
          .where("status", "not-in", ["REJECTED", "CANCELLED", "DRAFT"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getAllBookedCampaignsOfUserWithCoupon(userId, couponId) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");

        campaigns
          .where("userId", "==", userId)
          .where("couponId", "==", couponId)
          // statuses of a booked campaign
          .where("status", "not-in", ["REJECTED", "CANCELLED", "DRAFT"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getAllCampaignsWithCoupon(couponId) {
      return new Promise((fullfil, reject) => {
        const campaigns = this.collection("campaigns");

        campaigns
          .where("couponId", "==", couponId)
          // statuses of a booked campaign
          // .where("status", "not-in", ["REJECTED", "CANCELLED"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getAllRejectedCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "in", ["REJECTED", "CANCELLED"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getAllActiveCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    loadAllHistoricCampaigns() {
      return new Promise((fullfil) => {
        this.collection("campaigns")
          .where("status", "not-in", ["DRAFT", "REJECTED", "CANCELLED"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)));
      });
    },
    loadCampaignsByStatusCriteria(statusList) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "in", statusList)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    loadAllActiveCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "in", ["ACTIVE", "COMMENT_ANSWER_NEEDED"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    // TODO: COMMENT_ANSWER_NEEDED are also active??
    loadAllGoogleAdsActiveCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains-any", [
            "google-display",
            "youtube",
            "ebay-kleinanzeigen",
            "google-search"
          ])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getApplicantsByCampaignId(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("candidates")
          .where("campaignId", "==", campaignId)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },

    async getAllCampaigns(filters = {}) {
      const { organizationId, userId, filter } = filters;
      if (organizationId) {
        return await this.getCampaignsOfOrga(organizationId, "organizationId", filter);
      } else if (userId) {
        return await this.getCampaignsOfUserWithId(userId, "userId", filter);
      } else {
        return await this.collection("campaigns")
          .where("status", "in", [
            "ACTIVE",
            "PAUSED",
            "SCHEDULED",
            "WAITING_FOR_APPROVAL",
            "IN_PROGRESS",
            "COMMENT_ANSWER_NEEDED",
            "ACTION_REQUIRED"
          ])
          .get()
          .then(enrichSnapshotWithId);
      }
    },

    getActiveCampaignsByOrgaId(orgaId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("organizationId", "==", orgaId)
          .where("status", "==", "ACTIVE")
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },

    async getCampaignById({ campaignId }) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .get()
          .then((rawData) => fullfil(enrichRawData(rawData)))
          .catch(reject);
      });
    },

    loadAllHistoryCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "in", ["FINISHED"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getEntireCampaignsList() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },

    getFacebookCampaignWithId(orgaId, campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .get()
          .then((querySnapshot) => fullfil(querySnapshot.data().metrics.facebook))
          .catch(reject);
      });
    },
    getCampaignsWithCondition(field, operator, value) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where(field, operator, value)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getDraftNumberCampaignsOfOrg(orgaId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("organizationId", "==", orgaId)
          .where("status", "==", "DRAFT")
          .get()
          .then((querySnapshot) => fullfil(querySnapshot.size))
          .catch(reject);
      });
    },
    getBewerberHubCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("activeSourcingFeature", "in", [true, "true"])
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getLinkedInCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("channels", "array-contains", "linkedin")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getGoogle4JobsCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },
    getAdzunaCampaignsPromoted() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("postOnAdzunaPromoted", "==", true)
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },

    getAdzunaCampaigns() {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .where("status", "==", "ACTIVE")
          .where("postOnAdzuna", "==", true)
          .get()
          .then(fullfil)
          .catch(reject);
      });
    },

    updateCampaignListFields(campaignId, fieldName, value) {
      return new Promise((fullfil, reject) => {
        this.collection("campaigns")
          .doc(campaignId)
          .update({
            [fieldName]: firebase.firestore.FieldValue.arrayUnion(value)
          })
          .then(fullfil)
          .catch(reject);
      });
    },
    //==============================================================================
    // Campaign logs
    //=====================
    getCampaignLogs(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_logs_flat")
          .where("campaignId", "==", campaignId)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    addCampaignLog(campaignId, data) {
      //
      // `data` has to contain the following keys:
      // - message
      // - type (add, remove, change)
      // - userId
      // - date
      // - userName
      // - metaData
      //
      logger.debug("FirebaseController:addCampaignLog", "called", {
        campaignId,
        data
      });

      data.campaignId = campaignId;

      return new Promise((fullfil, reject) => {
        this.collection("campaign_logs_flat")
          .add(data)
          .then((result) => fullfil({ id: result && result.ref && result.ref.id }))
          .catch(reject);
      });
    },
    //==============================================================================
    // Campaign Notifications
    //=====================
    getCampaignNotifications(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_notifications")
          .where("campaignId", "==", campaignId)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    createCampaignNotifications(notificationData) {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_notifications").add(notificationData).then(fullfil).catch(reject);
      });
    },
    updateCampaignNotifications(notificationId, notificationData) {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_notifications")
          .doc(notificationId)
          .set(notificationData, { merge: true })
          .then(fullfil)
          .catch(reject);
      });
    },
    getAllCampaignNotificationsByStatuses(statuses) {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_notifications")
          .where("status", "in", statuses)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getCampaignNotificationsByType(campaignId, type) {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_notifications")
          .where("campaignId", "==", campaignId)
          .where("type", "==", type)
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getAllCampaignNotifications() {
      return new Promise((fullfil, reject) => {
        this.collection("campaign_notifications")
          .get()
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },

    updateCampaignQuestionMappingWithId(campaignId, data) {
      return new Promise((fulfill, reject) => {
        const questionMapping = data.integrations.recruitee.questionMapping;

        const newQuestionMapping = {};
        Object.entries(questionMapping).forEach(([questionId, mapping]) => {
          newQuestionMapping[questionId] =
            mapping === null ? firebase.firestore.FieldValue.delete() : mapping;
        });

        const updateData = {
          integrations: { recruitee: { questionMapping: newQuestionMapping } }
        };

        this.collection("campaigns")
          .doc(campaignId)
          .set(updateData, { merge: true })
          .then(fulfill)
          .catch(reject);
      });
    },

    getRealtimeCampaignLock({ campaignId, currentIsLocked, onUpdate, onError }) {
      const docRef = firebase.firestore().collection("campaigns").doc(campaignId);

      const unsubscribe = docRef.onSnapshot(
        (docSnapshot) => {
          if (!docSnapshot.exists) return;
          const data = docSnapshot.data();
          const newData = { ...data, id: docSnapshot.id };
          if (newData.isLocked !== currentIsLocked) {
            onUpdate(newData);
          }
        },
        (error) => onError(error)
      );
      return unsubscribe;
    },

    getRealtimeAdLock({ ads, onUpdate, onError }) {
      if (!ads || ads.length === 0) return () => {};
      const docRef = firebase
        .firestore()
        .collection("ads")
        .where(
          firebase.firestore.FieldPath.documentId(),
          "in",
          ads.map((ad) => ad.id)
        );

      const currentLocks = {};

      const unsubscribe = docRef.onSnapshot(
        (querySnapshot) => {
          querySnapshot.docChanges().forEach((change) => {
            const doc = change.doc;
            const adId = doc.id;
            const data = doc.data();
            const newData = { ...data, id: adId };
            const newLock = newData.isLocked;
            const prevLock = currentLocks[adId];

            // Only call onUpdate if we have seen this ad before and the lock changed
            if (prevLock !== undefined && prevLock !== newLock) {
              onUpdate(newData);
            }
            currentLocks[adId] = newLock;
          });
        },
        (error) => onError(error)
      );
      return () => unsubscribe();
    }
  };
};
